<template>
  <div class="team">
    <v-row>
      <v-col cols="12" sm="4">
        <p class="text-h6 mb-0 mb-sm-4">チーム</p>
      </v-col>
      <v-col cols="12" sm="8" style="display:flex;justify-content:flex-end;" class="pt-0 pt-sm-3 mb-3 pb-sm-5">
        <v-btn color="info" outlined @click="openPDF('about_team')">
          チームで取組む
          <v-icon right dark>mdi-open-in-new</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <h4 class="team-title">
      チームランキング
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-icon color="blue" v-bind="attrs" v-on="on" style="margin-left:10px">
            mdi-help-circle
          </v-icon>
        </template>
        <span>ランキングは1時間に1回更新されます。(9時から21時)</span>
      </v-tooltip>
    </h4>
    <v-row class="mb-6">
      <v-col cols="12" sm="4" v-for="team in teamRankingList" :key="team.rank" class="py-0">
        <v-list-item>
          <v-list-item-icon class="rank-icon">
            <v-icon v-if="team.rank === 1" color="gold" large>mdi-crown</v-icon>
            <v-icon v-if="team.rank === 2" color="silver" large>mdi-crown</v-icon>
            <v-icon v-if="team.rank === 3" color="bronze" large>mdi-crown</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title :class="{'font-weight-black': team.rank === 1}">
              {{team.rank}} 位  {{team.name}}
            </v-list-item-title>
            <v-list-item-subtitle>
              平均{{team.average_point}}pt  /  {{team.member_count}}人
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-col>
    </v-row>
    <v-alert
      v-if="teamRankingList.length === 0 && !isLoading"
      border="left"
      colored-border
      type="info"
      elevation="2"
      style="font-size: 90%"
    >
      ランキングデータがありません。
    </v-alert>
    <div class="text-right">
      <v-btn to="/teamRanking" text color="link">さらに見る</v-btn>
    </div>

    <!-- チームに参加している時 -->
    <div v-if="isJoinTeam && !isLoading">
      <h4 class="team-title">あなたのチーム</h4>
      <v-row>
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle style="line-height: 24px;">
                チームID
              </v-list-item-subtitle>
              <v-list-item-title>{{teamInfo.id}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle style="line-height: 24px;">
                  チーム名
                </v-list-item-subtitle>
              <v-list-item-title>{{teamInfo.name}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle style="line-height: 24px;">
                チームパスワード
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon color="blue" v-bind="attrs" v-on="on">
                      mdi-help-circle
                    </v-icon>
                  </template>
                  <span>他のユーザーを招待する際に、チームIDとパスワードを伝えてください。</span>
                </v-tooltip>
              </v-list-item-subtitle>
              <v-list-item-title>{{teamInfo.password}}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-subtitle style="line-height: 24px;">
                チーム人数
              </v-list-item-subtitle>
              <v-list-item-title>
                {{listTeamUser.length}}人
                <span v-if="listTeamUser.length < 5">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="warning" v-bind="attrs" v-on="on">
                        mdi-alert
                      </v-icon>
                    </template>
                    <span>ランキング対象は、5人以上のチームです。</span>
                  </v-tooltip>
                </span>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
      <div class="team-table">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">リーダー</th>
                <th class="text-left" style="width:150px">氏名</th>
                <th class="text-left" style="width:250px" v-if="!isMobile">選択コース</th>
                <th class="text-left">ポイント</th>
                <th class="text-left" v-if="campaignOption.is_walking_travel">地点</th>
                <th class="text-left" v-if="campaignOption.is_walking_travel">名所</th>
                <th class="text-left" v-if="isMobile">選択コース数</th>
                <th class="text-left" v-if="campaign.required_advanced_course_count > 0 && isMobile">選択アドバンスコース数</th>
                <th class="text-left">達成コース数</th>
                <th class="text-left" v-if="campaign.required_advanced_course_count > 0">達成アドバンスコース数</th>
                <th class="text-left" v-if="campaign.is_continue_bonus">クローバーマーク獲得数</th>
                <th class="text-left">未入力日数</th>
                <th class="text-left">最終記録日</th>
                <th class="text-left">達成賞対象</th>
                <th class="text-left" v-if="campaign.is_continue_bonus">継続ボーナス対象</th>
                <th class="text-left">終了時アンケート回答状況</th>
                <th class="text-left" v-if="isCampaignPeriod">チームを脱退</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(userView) of listTeamUser" :key="userView.id">
                <td>
                  <v-icon v-if="teamInfo.team_owner === userView.id">
                    mdi-check
                  </v-icon>
                </td>
                <td>{{userView.name}}</td>
                <td v-if="!isMobile">
                  <div v-for="(course) of userView.custom_objective_list" :key="course.course_id">
                    {{course.course_name}}
                    <span v-if="course.custom_objective">
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on">mdi-note</v-icon>
                        </template>
                        <span>{{course.custom_objective}}</span>
                      </v-tooltip>
                    </span>
                  </div>
                </td>
                <td>{{userView.total_point === null ? 0 : userView.total_point}}</td>
                <td v-if="campaignOption.is_walking_travel">
                  {{userView.current_walking_point === null ? '未選択' : userView.current_walking_point}}
                </td>
                <td v-if="campaignOption.is_walking_travel">
                  {{userView.current_walking_specialty === null ? '未選択' : userView.current_walking_specialty}}
                </td>
                <td v-if="isMobile">{{userView.selected_course === null ? 0 : userView.selected_course}}</td>
                <td v-if="campaign.required_advanced_course_count > 0 && isMobile">
                  {{userView.advanced_course === null ? 0 : userView.advanced_course}}
                </td>
                <td>{{userView.completed_course === null ? 0 : userView.completed_course}}</td>
                <td v-if="campaign.required_advanced_course_count > 0">
                  {{userView.completed_advanced_course === null ? 0 : userView.completed_advanced_course}}
                </td>
                <td v-if="campaign.is_continue_bonus">
                  {{userView.continue_bonus_point === null ? 0 : userView.continue_bonus_point}}
                </td>
                <td>{{0 > (campaignDays - userView.input_count) ? 0 : campaignDays - userView.input_count}}</td>
                <td>{{userView.last_record_at | formatDate}}</td>
                <td>
                  <v-icon v-if="userView.is_prizewinner || userView.is_app_completed || userView.is_no_smoking_completed">
                    mdi-check
                  </v-icon>
                </td>
                <td v-if="campaign.is_continue_bonus">
                  <v-icon v-if="userView.is_continue_bonus_complete">
                    mdi-check
                  </v-icon>
                </td>
                <td>{{userView.questionnaire_answer_at === null ? '未回答' : '回答済み'}}</td>
                <td v-if="isCampaignPeriod">
                  <v-btn
                    v-if="teamInfo.team_owner === campaignUser.id && userView.username !== campaignUser.id"
                    @click="leaveTeam(userView)"
                    x-small
                    color="grey lighten-2"
                  >
                    脱退
                  </v-btn>
                  <v-btn
                    v-if="teamInfo.team_owner !== campaignUser.id && userView.username === campaignUser.id"
                    @click="leaveTeam(userView)"
                    x-small
                    color="grey lighten-2"
                  >
                    脱退
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
      <v-row class="mt-3">
        <v-spacer></v-spacer>
        <v-col cols="auto" v-if="teamInfo.team_owner === campaignUser.id && isCampaignPeriod">
          <v-btn @click="deleteTeam()" color="grey lighten-2" :loading="isLoading">
            チームを削除
          </v-btn>
        </v-col>
      </v-row>
      <TeamBoard
        :campaignUser="campaignUser"
        :listTeamUser="this.listTeamUser"
        :teamId="this.teamInfo.id"
        @childErrorHandling="childErrorHandling"
        v-if="isTeamBoard"
      />
    </div>

    <!-- チームに未参加の時 -->
    <div v-else-if="!isJoinTeam && !isLoading && isCampaignPeriod" class="create-team">
      <h4 class="team-title">チームに参加する</h4>
      <v-row>
        <v-col cols="12" md="6">
          <validation-observer
            ref="observer"
          >
            <span>①チームを作成する。</span>
            <validation-provider
              name="チーム名"
              rules="required|max:20"
              v-slot="{ errors }"
            >
              <v-text-field
                v-model="inputTeamName"
                :error-messages="errors"
                label="チーム名"
                outlined
                dense />
            </validation-provider>
            <div>
              <span class="red--text" style="">※機種依存文字などの特殊文字（例：♡、©、㌕）は使用しないでください</span>
            </div>
            <v-btn
              @click="createTeam()"
              depressed
              color="primary"
              class="mt-2"
            >
              チームを作成
            </v-btn>
          </validation-observer>
        </v-col>
        <v-col cols="12" md="6">
          <validation-observer
            ref="join_team"
          >
            <span>②既存のチームに参加する。</span>
            <validation-provider
              name="チーム名"
              rules="required"
              v-slot="{ errors }"
            >
              <v-autocomplete
                v-model="selectTeam"
                :items="existTeamList"
                :error-messages="errors"
                label="チームIDまたはチーム名"
                item-text="label"
                item-value="value"
                no-data-text="チームが存在しません"
                outlined
                dense>
              </v-autocomplete>
            </validation-provider>
            <validation-provider
              name="チームパスワード"
              rules="required|teamPassword"
              v-slot="{ errors }"
            >
              <v-text-field
                v-model="inputPassword"
                :error-messages="errors"
                label="チームパスワード（数字4桁）"
                outlined
                dense />
            </validation-provider>
            <v-btn
              @click="joinTeam()"
              depressed
              color="primary"
              class="mt-2"
            >
              チームに参加
            </v-btn>
          </validation-observer>
        </v-col>
      </v-row>
    </div>

    <!-- 共通コンポーネント -->
    <Dialog ref="confirm"/>
    <SuccessSnackbar ref="snackbar"/>
    <div class="text-center">
      <v-progress-circular v-if="isLoading" indeterminate color="secondary" />
    </div>
  </div>
</template>

<script>
import GraphqlAPI from '../../utils/GraphqlAPI'
import { required, max } from 'vee-validate/dist/rules'
import { localize, extend, ValidationObserver, ValidationProvider, setInteractionMode } from 'vee-validate'
import ja from 'vee-validate/dist/locale/ja.json'
import dayjs from 'dayjs'
const Dialog = () => import('../util/Dialog.vue')
const SuccessSnackbar = () => import('../util/SuccessSnackbar.vue')
const TeamBoard = () => import('./TeamBoard')

// バリデーションの定義
setInteractionMode('eager')
localize('ja', ja)
extend('required', required)
extend('max', max)
extend('teamPassword', (value) => {
  const inputCode = value.replace(/[０-９]/g, function (s) {
    return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
  })
  return /^[0-9]{4}$/.test(inputCode) || '{_field_} は4桁の数字で入力してください'
})

// チームランキングリストクエリ
const listTeamRankingQuery = (campaignId) => `
  query listTeamRanking {
    listTeamRanking(campaign_id: "${campaignId}") {
      ranking {
        rank
        team {
          office_code
          name
          ranking_member_count
          total_point
          average_point
        }
      }
    }
  }
`
const fetchListTeamRanking = async (campaignId) => {
  const { data: { listTeamRanking: data } } = await GraphqlAPI(listTeamRankingQuery(campaignId))
  return {
    ranking: data.ranking.map((item) => {
      return {
        rank: item.rank,
        office_code: item.team.office_code,
        name: item.team.name,
        member_count: item.team.ranking_member_count,
        total_point: item.team.total_point,
        average_point: item.team.average_point
      }
    })
  }
}

// 実行ユーザーUserViewクエリ
const getUserViewQuery = (campaignId) => `
  query getUserView {
    getUserView(campaign_id: "${campaignId}") {
      id
      team_id
      team_name
      username
      name
      certificate_number
      total_point
      selected_course
      advanced_course
      completed_course
      completed_advanced_course
      input_count
      questionnaire_answer_at
      last_record_at
      is_continue_bonus_complete
      continue_bonus_point
      is_prizewinner
      is_app_completed
      is_no_smoking_completed
      current_walking_point
      current_walking_specialty
      custom_objective_list {
        course_id,
        custom_objective
      }
    }
  }
`
const getUserViewInfo = async (campaignId) => {
  const { data: { getUserView: data } } = await GraphqlAPI(getUserViewQuery(campaignId))
  return data
}

// チームユーザーのUserViewクエリ
const listTeamUserQuery = (campaignId, teamId) => `
  query listTeamUser {
    listTeamUser(campaign_id: "${campaignId}", team_id: "${teamId}") {
      users {
        id
        username
        name
        certificate_number
        total_point
        selected_course
        advanced_course
        completed_course
        completed_advanced_course
        input_count
        questionnaire_answer_at
        last_record_at
        is_continue_bonus_complete
        continue_bonus_point
        is_prizewinner
        is_app_completed
        is_no_smoking_completed
        current_walking_point
        current_walking_specialty
        custom_objective_list {
          course_id,
          custom_objective
        }
      }
    }
  }
`
const getListTeamUser = async (campaignId, teamId) => {
  const { data: { listTeamUser: data } } = await GraphqlAPI(listTeamUserQuery(campaignId, teamId))
  return data.users
}

// 参加可能チームリストクエリ
const listExistTeamQuery = (campaignId) => `
  query listExistTeam {
    listExistTeam(campaign_id: "${campaignId}") {
      teams {
        id
        name
        team_owner
        password
      }
    }
  }
`
const getListExistTeam = async (campaignId) => {
  const { data: { listExistTeam: data } } = await GraphqlAPI(listExistTeamQuery(campaignId))
  return data.teams.map((item) => {
    return {
      ...item,
      label: item.id + ' : ' + item.name,
      value: {
        id: item.id,
        name: item.name
      }
    }
  })
}

// チーム情報取得クエリ
const getTeamQuery = (teamId, campaignId) => `
  query getTeam {
    getTeam(
      team_id: "${teamId}",
      campaign_id: "${campaignId}"
    ){
      id
      name
      team_owner
      password
    }
  }
`
const gqGetTeam = async (teamId, campaignId) => {
  const { data: { getTeam: data } } = await GraphqlAPI(getTeamQuery(teamId, campaignId))
  return data
}

// チーム作成
const createTeamMutation = (campaignId, teamName) => `
  mutation createTeam {
    createTeam(
      campaign_id: "${campaignId}",
      input: {
        name: "${teamName}"
      }
    ){
      status
      condition
      team {
        id
        name
        team_owner
        password
      }
    }
  }
`
const fetchCreateTeam = async (campaignId, teamName) => {
  const { data: { createTeam: data } } = await GraphqlAPI(createTeamMutation(campaignId, teamName))
  return data
}

// チーム参加
const joinTeamMutation = (campaignId, teamId, password) => `
  mutation joinTeam {
    joinTeam(
      campaign_id: "${campaignId}",
      input: {
        team_id: "${teamId}",
        password: "${password}"
      }
    ){
      status
      condition
      team {
        id
        name
        team_owner
        password
      }
    }
  }
`
const fetchJoinTeam = async (campaignId, teamId, password) => {
  const { data: { joinTeam: data } } = await GraphqlAPI(joinTeamMutation(campaignId, teamId, password))
  return data
}

// チーム脱退
const leaveTeamMutation = (campaignId, username, teamId) => `
  mutation leaveTeam {
    leaveTeam(
      campaign_id: "${campaignId}",
      username: "${username}",
      team_id: "${teamId}"
    )
  }
`
const fetchLeaveTeam = async (campaignId, username, teamId) => {
  const { data: { leaveTeam: data } } = await GraphqlAPI(leaveTeamMutation(campaignId, username, teamId))
  return data
}

// チーム削除
const deleteTeamQuery = (teamId, campaignId) => `
  mutation deleteTeam {
    deleteTeam(
      campaign_id: "${campaignId}",
      team_id: "${teamId}"
    )
  }
`
const gqDeleteTeam = async (teamId, campaignId) => {
  const { data: { deleteTeam: data } } = await GraphqlAPI(deleteTeamQuery(teamId, campaignId))
  return data
}

// コース取得
const listCourseQuery = (campaignId) => `
  query getListCourse {
    listCourse(campaign_id: "${campaignId}") {
      courses {
        id
        name
      }
    }
  }
`

const getListCourse = async (campaignId) => {
  const { data: { listCourse: data } } = await GraphqlAPI(listCourseQuery(campaignId))
  return data
}

export default {
  name: 'team',
  components: {
    Dialog,
    SuccessSnackbar,
    ValidationProvider,
    ValidationObserver,
    TeamBoard
  },
  props: ['campaignUser'],
  data () {
    return {
      title: 'チーム',
      // チームランキング
      teamRankingList: [],

      // チーム新規作成
      inputTeamName: '',

      // 既存チームへ参加
      existTeamList: [],
      inputPassword: '',
      selectTeam: '',

      // チームメンバリスト
      listTeamUser: [],
      campaignDays: 0,
      myUserView: {},
      teamInfo: {},

      // その他
      isCampaignPeriod: false,
      isJoinTeam: false,
      isLoading: false,
      isTeamBoard: false
    }
  },
  computed: {
    campaign () {
      return this.$store.getters.getCampaign
    },
    campaignOption () {
      return this.$store.getters.getCampaignOption
    },
    isMobile () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return true
        case 'sm': return true
        case 'md': return false
        case 'lg': return false
        case 'xl': return false
      }
      return false
    }
  },
  async created () {
    this.isLoading = true
    this.isTeamBoard = this.campaignOption.is_team_board
    const getTeamRankingList = fetchListTeamRanking(this.campaign.id)
    const getExistTeamList = getListExistTeam(this.campaign.id)
    const getUserViewData = getUserViewInfo(this.campaign.id)
    const getCourceList = getListCourse(this.campaign.id)
    const me = this
    Promise.all([getTeamRankingList, getExistTeamList, getUserViewData, getCourceList])
      .then(function (responce) {
        me.teamRankingList = responce[0].ranking
        me.existTeamList = responce[1]
        me.myUserView = responce[2]
        me.courceList = responce[3]
        me.isJoinTeam = Boolean(responce[2].team_id)
        return responce[2].team_id
      })
      .then(function (teamId) {
        (async () => {
          try {
            if (teamId) {
              me.listTeamUser = await getListTeamUser(me.campaign.id, teamId)
              for (const user of me.listTeamUser) {
                for (const selectCource of user.custom_objective_list) {
                  const course = me.courceList.courses.find(el => selectCource.course_id === el.id)
                  selectCource.course_name = course.name
                }
              }
              me.teamInfo = await gqGetTeam(teamId, me.campaign.id)
            }
            me.isLoading = false
          } catch (e) {
            me.$emit('errorHandling', 'チームの取得に失敗しました。' + e.errors[0].message)
            me.isLoading = false
          }
        })()
      })
    // 今日までのキャンペーン期間算出、キャンペーン期間終了後は固定
    const startDate = dayjs(this.campaign.start, 'YYYY-MM-DD')
    const endDate = dayjs(this.campaign.end, 'YYYY-MM-DD')
    const siteClose = dayjs(this.campaign.site_close, 'YYYY-MM-DD').add(1, 'days')
    const nowDate = dayjs()
    this.isCampaignPeriod = nowDate < siteClose
    if (nowDate < endDate) {
      this.campaignDays = dayjs(nowDate).diff(dayjs(startDate), 'days') + 1
    } else {
      this.campaignDays = dayjs(endDate).diff(dayjs(startDate), 'days') + 1
    }
  },
  methods: {
    // チーム新規作成、参加
    async createTeam () {
      const isValidate = await this.$refs.observer.validate()
      if (isValidate) {
        if (await this.$refs.confirm.open(null, 'チームを作成します。よろしいですか。')) {
          try {
            this.isLoading = true
            const responseTeam = await fetchCreateTeam(this.campaign.id, this.inputTeamName)
            if (responseTeam.status) {
              this.teamInfo = responseTeam.team
              for (const selectCource of this.myUserView.custom_objective_list) {
                const course = this.courceList.courses.find(el => selectCource.course_id === el.id)
                selectCource.course_name = course.name
              }
              this.listTeamUser.push(this.myUserView)
              this.isJoinTeam = true
              await this.$refs.snackbar.open('チームを作成しました。')
            } else {
              if (responseTeam.condition === 'TeamNameUnique') {
                this.$emit('errorHandling', '既に同じチーム名が存在するため、チームの作成ができませんでした。')
              }
            }
            this.isLoading = false
          } catch (e) {
            this.$emit('errorHandling', 'チーム作成に失敗しました。' + e.errors[0].message)
            this.$log.debug(e)
            this.isLoading = false
          }
        }
      }
    },
    // 既存のチームに参加
    async joinTeam () {
      const isValidate = await this.$refs.join_team.validate()
      if (isValidate) {
        if (await this.$refs.confirm.open(null, 'チームに参加します。よろしいですか。')) {
          try {
            this.isLoading = true
            const inputPassword = this.inputPassword.replace(/[０-９]/g, function (s) {
              return String.fromCharCode(s.charCodeAt(0) - 0xFEE0)
            })
            const responseTeam = await fetchJoinTeam(this.campaign.id, this.selectTeam.id, inputPassword)
            if (responseTeam.status) {
              this.teamInfo = responseTeam.team
              this.listTeamUser = await getListTeamUser(this.campaign.id, this.teamInfo.id)
              // StreamによるUserView更新にタイムラグがあるので、取得したリストに自分のデータがなければ追加
              if (!this.listTeamUser.find(teamUser => teamUser.username === this.campaignUser.id)) {
                this.listTeamUser.push(this.myUserView)
              }
              // コース名の設定
              for (const user of this.listTeamUser) {
                for (const selectCource of user.custom_objective_list) {
                  const course = this.courceList.courses.find(el => selectCource.course_id === el.id)
                  selectCource.course_name = course.name
                }
              }
              this.isJoinTeam = true
              await this.$refs.snackbar.open('チームに参加しました。')
            } else {
              if (responseTeam.condition === 'InvalidPassword') {
                this.$emit('errorHandling', 'チームパスワードが間違っていたため、チームへの参加ができませんでした。')
              } else if (responseTeam.condition === 'TeamMemberLimitOver') {
                this.$emit('errorHandling', 'チーム定員20名に達したため、チームへの参加ができませんでした。')
              } else if (responseTeam.condition === 'InvalidOfficeCode') {
                this.$emit('errorHandling', 'チームの所属が一致しないため、チームへの参加ができませんでした。')
              }
            }
            this.isLoading = false
          } catch (e) {
            this.$emit('errorHandling', 'チームの参加に失敗しました。' + e.errors[0].message)
            this.$log.debug(e)
            this.isLoading = false
          }
        }
      }
    },
    // チームから脱退する
    async leaveTeam (targetUser) {
      let message = ''
      let manageFlg = false
      if (targetUser.username === this.campaignUser.id) {
        message = 'チームから脱退します。よろしいですか。'
      } else {
        message = targetUser.name + 'さんをチームから脱退させます。よろしいですか。'
        manageFlg = true
      }
      if (await this.$refs.confirm.open(null, message)) {
        try {
          this.isLoading = true
          await fetchLeaveTeam(this.campaign.id, targetUser.username, this.teamInfo.id)

          // 自分が脱退ではないとき、チームユーザーリストを更新
          if (manageFlg) {
            this.listTeamUser = this.listTeamUser.filter(user => {
              return user.username !== targetUser.username
            })
            await this.$refs.snackbar.open('チームから脱退させました。')

          // 自分が脱退するの時のみ初期化
          } else {
            this.isJoinTeam = false
            this.teamInfo = {}
            this.existTeamList = await getListExistTeam(this.campaign.id)
            this.inputTeamName = ''
            this.inputPassword = ''
            this.selectTeam = ''
            this.listTeamUser = []
            await this.$refs.snackbar.open('チームから脱退しました。')
          }
          this.isLoading = false
        } catch (e) {
          this.$emit('errorHandling', 'チームの脱退に失敗しました。' + e.errors[0].message)
          this.$log.debug(e)
          this.isLoading = false
        }
      }
    },
    // チームを削除する（チーム作成者のみ可能）
    async deleteTeam () {
      try {
        if (this.teamInfo.team_owner !== this.campaignUser.id) {
          throw new Error('チーム作成者以外がチームを削除しようとしています。')
        }
        this.isLoading = true
        if (await this.$refs.confirm.open(null, 'チームを削除します。よろしいですか。')) {
          await gqDeleteTeam(this.teamInfo.id, this.campaign.id)
          this.isJoinTeam = false
          this.teamInfo = {}
          this.existTeamList = await getListExistTeam(this.campaign.id)
          this.inputTeamName = ''
          this.inputPassword = ''
          this.selectTeam = ''
          this.listTeamUser = []
        }
        this.isLoading = false
      } catch (e) {
        this.$emit('errorHandling', 'チームの削除に失敗しました。')
        this.$log.debug(e)
        this.isLoading = false
      }
    },
    childErrorHandling (message) {
      this.$emit('errorHandling', message)
    },
    openPDF (target) {
      window.open('/manual/' + target + '.pdf', '_blank')
    }

  }
}
</script>

<style scoped lang="scss">
.team-title {
  margin-bottom: 1rem;
}
.rank-icon {
  margin: 7px 16px 7px 20px !important;
}
.team-table > .v-data-table ::v-deep th {
  border-right: 1px solid #c4c4c4 !important;
  background-color: #FFF8E1 !important;
}
.team-table > .v-data-table ::v-deep td {
  border-right: 1px solid #c4c4c4 !important;
}
.team-table > .v-data-table ::v-deep div.v-data-table__wrapper {
  border: 1px solid #c4c4c4 !important;
  border-right: 0px !important;
}
</style>
